import React, { useState } from 'react';
import { useNCZIContext } from '../../Services/NCZIContext';
import { usePatientTreatmentContext } from '../../../Patient/Components/PatientTreatment/ContextProvider';
import { useLazyUserNcziProfileQuery } from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import Loading from '../../../../Components/Loading';
import PatientInsuranceSetup from '../PatientInsuranceSetup/PatientInsuranceSetup';

//@ts-ignore
import styles from './NCZIPatient.module.scss';

interface Props {
  children: React.ReactElement | React.ReactElement[];
}

const NCZIInsuredPatient: React.FC<Props> = ({ children }) => {
  const {
    patientBirthNumber,
    setPatientBirthNumber,
    patientInsurance,
    setPatientMeddiInsurance
  } = useNCZIContext();
  const { patientId } = usePatientTreatmentContext();
  const [ getLazyUserNczi ] = useLazyUserNcziProfileQuery();
  const [ needInsuranceSetup, setNeedInsuranceSetup ] = useState<boolean>(true);

  const handleLoadPatientData = async () => {
    const { user } = await getLazyUserNczi({
      id: patientId,
    }).unwrap();

    if (user?.profile?.birthNumber) {
      setPatientBirthNumber(user.profile.birthNumber);
    }

    if(user?.profile?.insuranceCompanyTermItem?.value3) {
      setPatientMeddiInsurance(user.profile.insuranceCompanyTermItem.value3);
    } else {
      setPatientMeddiInsurance(null);
    }

    // if (user?.profile?.insuranceCompanyTermItem?.value3) {
    //   setPatientInsurance(user.profile.insuranceCompanyTermItem.value3);
    // } else {
    setNeedInsuranceSetup(true);
    // }
  };

  const handleLoadData = async () => {
    if(!patientBirthNumber || !patientInsurance) {
    	await handleLoadPatientData();
    }
  };

  useEffectAsync(async () => {
    await handleLoadData();
    if(patientInsurance) {
      setNeedInsuranceSetup(false);
    }
  }, [patientBirthNumber, patientInsurance]);

  if (!patientBirthNumber || (!patientInsurance && !needInsuranceSetup)) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loadingWrapper}>
          <Loading />
        </div>
      </div>
    );
  }

  if(needInsuranceSetup) {
    return (
      <>
        <PatientInsuranceSetup patientId={patientId} />
      </>
    );
  }

  return (
    <>
      {children}
    </>
  );
};

export default NCZIInsuredPatient;
